const cartNavigationStorage = "cartNavigation"

export const navigateToCart = (history: any, previousRouteLocationState?: any, cartLocationState?: any) => {
  if (previousRouteLocationState) {
    const cartNavigationData = { pathname: history.location.pathname, state: previousRouteLocationState }
    localStorage.setItem(cartNavigationStorage, JSON.stringify(cartNavigationData));
  }
  if (cartLocationState) history.push("/cart", cartLocationState)
  history.push('/cart')
}